import React, { useEffect } from 'react'
import { BrowserRouter } from "react-router-dom";
import './App.css';
import 'moment/locale/mn'
import moment from 'moment'
import { ToastContainer } from 'react-toastify';
import AuthContext from "./context/AuthContext"
import  Router  from "./config/Router";
import * as feather from 'feather-icons/dist/feather.min';


function App(){
  
  moment.locale('mn');

  
  useEffect(() => {
    feather.replace();
  }, []);



  return (
    <AuthContext>
      <BrowserRouter>
            {/* {routing} */}
            <ToastContainer />
            <Router />
        
      </BrowserRouter>
    </AuthContext>
  );
}

export default App;
